import React, { useEffect, useState } from 'react';
import { Table, Avatar, Space, Tooltip } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { BASE_URL, DateFormat, DateTimeFormat } from '../Components/Constant';
import ApiService from '../Components/apiService';
import dayjs from 'dayjs';
import {convertDateToUserTimezone} from '../Components/Utility';

const FieldHistory = ({fields}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { record } = location.state || {};
  const [arrayData, setArrayData] = useState([]);
  const [userMap, setUserMap] = useState({});
  const [currentPage, setCurrentPage] = useState(1); // Track pagination state

  // Fetch user details and create a mapping
  const fetchUserDetails = async () => {
    try {
      const apiServiceForRecords = new ApiService(
        `${BASE_URL}/fetch_records/User`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiServiceForRecords.makeCall();
      console.log('userss',response)
      if (response && Array.isArray(response?.records)) {
        const userMapping = response?.records?.reduce((acc, user) => {
          acc[user._id] = { Name: user.Name || 'Unknown', userId: user._id };
          return acc;
        }, {});
        setUserMap(userMapping);
        console.log('userMap:', userMap);

      } else {
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    if (!record || !record._id) {
      return;
    }

    const fetchFieldHistory = async () => {
      try {
        const apiService = new ApiService(
          `${BASE_URL}/field_history/${record._id}`,
          'GET'
        );
        const response = await apiService.makeCall();

        if (response && Array.isArray(response)) {
          const finalRes = response.map((item) => ({
            key: item._id,
            date: dayjs(item.changed_at).format(DateTimeFormat),
            field: item.field_name,
            user: item.changed_by || 'Unknown',
            originalvalue: item.old_value,
            newvalue: item.new_value,
          }));
          setArrayData(finalRes.filter(Boolean));
        } else {
          console.warn('Unexpected field history response format:', response);
        }
      } catch (error) {
        console.error('Error while fetching field tracking data:', error);
      }
    };

    fetchUserDetails();
    fetchFieldHistory();
  }, [record]);

  // Replace user IDs with Names when userMap updates
  console.log('userMap:', userMap);

  const dataWithNames = arrayData
    .map((item) => ({
      ...item,
      user: userMap[item.user] || { Name: item.user, userId: null },
    }))
    .sort((a, b) => new Date(b.date) - new Date(a.date)); // Sort by descending date

    const getFieldFormat = (fieldName) => {
      if (!fields) return null;
      const fieldMeta = fields.find((f) => f.name === fieldName);
      if (!fieldMeta) return null;
    
      if (fieldMeta.type === 'date') return DateFormat;
      else if (fieldMeta.type === 'datetime') return DateTimeFormat;
      else return null;
    };
    
    const columns = [
      {
        title: 'Created/Updated At',
        dataIndex: 'date',
        width: 150,
      },
      {
        title: 'Field',
        dataIndex: 'field',
        width: 120,
      },
      {
        title: 'User',
        dataIndex: 'user',
        width: 200,
        render: (user) => {
          const { Name, userId } = user;
          return (
            <Space>
              <Avatar style={{
                    backgroundColor: '#87d068',
                }}
                size={25}>
                  {(Name || 'U').charAt(0).toUpperCase()}</Avatar>
              {userId ? (
                <a
                  href={`/record/User/${userId}`}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/record/User/${userId}`);
                  }}
                >
                  {Name}
                </a>
              ) : (
                <span>{Name}</span>
              )}
            </Space>
          );
        },
      },
      {
        title: 'Original Value',
        dataIndex: 'originalvalue',
        width: 250,
        render: (text, record) => {
          const format = getFieldFormat(record.field);
          if (format && text && dayjs(text).isValid()) {
            return (
              <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {convertDateToUserTimezone(text, format)}
              </div>
            );
          }
          return <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{text}</div>;
        },
      },
      {
        title: 'New Value',
        dataIndex: 'newvalue',
        width: 250,
        render: (text, record) => {
          const format = getFieldFormat(record.field);
          if (format && text && dayjs(text).isValid()) {
            return (
              <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {convertDateToUserTimezone(text, format)}
              </div>
            );
          }
          return <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{text}</div>;
        },
      },
    ];
    
    const isDateField = (fieldName) => {
      console.log('fieldssss',fieldName,fields)
      if (!fields) return false;
      const fieldMeta = fields.find((f) => f.name === fieldName);
      if (!fieldMeta) return false;
      return fieldMeta.type === 'date' || fieldMeta.type === 'datetime';
    };
    
  return (
    <div style={{ minHeight: '244px'}}>
      <Table
        columns={columns}
        dataSource={dataWithNames}
        pagination={{
          current: currentPage,
          pageSize: 3,
          onChange: (page) => setCurrentPage(page),
        }}
      />
    </div>
  );
};

export default FieldHistory;
